import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5PdfPageSelectionEdit } from "./edit";
import { A5PdfPageSelectionNew } from "./new";
import { A5PdfPageSelectionTable } from "./table";

export default function A5PdfPageSelection() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_s_lection_de_pages_pdf", {
        ns: "titles",
        defaultValue: "Quantilia | PDF Page Selection",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route path=":id" element={<A5PdfPageSelectionEdit />} />
      <Route index element={<A5PdfPageSelectionTable />} />
      <Route path="/new" element={<A5PdfPageSelectionNew />} />
    </Routes>
  );
}
